export default __webpack_public_path__ + "static/media/Almamegretta.d4773664.jpg";